"use client"

import { useState } from "react"
import { HiVolumeOff, HiVolumeUp } from "react-icons/hi"
import { HiChevronLeft, HiChevronRight } from "react-icons/hi2"

const videoSources = [
    "https://static.rovitravel.com/banner_vid.mp4",
]

const HeroSection = () => {
    const [currentIndex] = useState(0)
    const [isMuted, setIsMuted] = useState(true)

    const toggleMute = () => {
        setIsMuted(!isMuted)
    }

    const currentVideoSrc = videoSources[currentIndex]

    return (
        <section className="relative w-full py-0 bg-white">
            <style dangerouslySetInnerHTML={{
                __html: `
                @keyframes bounce-horizontal {
                    0%, 100% { transform: translateX(0); animation-timing-function: cubic-bezier(0.8, 0, 1, 1); }
                    50% { transform: translateX(-25%); animation-timing-function: cubic-bezier(0, 0, 0.2, 1); }
                }
            `}} />

            <div className="relative w-full px-5 md:px-6 lg:px-8 xl:px-10 overflow-visible">
                {/* KHUNG VIDEO */}
                <div
                    className="relative w-full 
                    -mr-20 md:-mr-32 lg:-mr-48 xl:-mr-64 2xl:-mr-80
                    h-[50vh] md:h-[60vh] lg:h-[500px] xl:h-[580px] 2xl:h-[650px] min-[1920px]:h-[720px]
                    rounded-2xl overflow-hidden"
                >
                    <video
                        key={currentIndex}
                        className="absolute inset-0 w-full h-full object-cover"
                        src={currentVideoSrc}
                        autoPlay
                        muted={isMuted}
                        loop
                        playsInline
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/15 via-black/5 to-transparent pointer-events-none" />

                    {/* Nút bật/tắt âm thanh */}
                    <div className="absolute bottom-3 right-3 md:bottom-6 md:right-6 z-20">
                        <button
                            onClick={toggleMute}
                            className="p-1.5 md:p-2 bg-black/40 backdrop-blur-md border border-white/20 rounded-full text-white hover:bg-black/60 transition-all"
                        >
                            {isMuted ?
                                <HiVolumeOff className="size-3.5 md:size-4" /> :
                                <HiVolumeUp className="size-3.5 md:size-4" />
                            }
                        </button>
                    </div>
                </div>
            </div>

            {/* CHỮ "SCROLL DOWN →" */}
            <div className="hidden md:block absolute bottom-30 2xl:bottom-40 right-0 -translate-x-1 -rotate-90 origin-bottom-right z-12">
                <div className="flex items-center gap-2 text-black/60">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1"
                        stroke="currentColor"
                        style={{ animation: 'bounce-horizontal 1s infinite' }}
                        className="w-5 h-5 2xl:w-6 2xl:h-6"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                    </svg>

                    <p className="font-normal tracking-[0.12em] uppercase whitespace-nowrap
                            text-[11px]
                            xl:text-[11px] 
                            2xl:text-[14px] 
                            min-[1920px]:text-[20px]"
                    >
                        Scroll Down
                    </p>
                </div>
            </div>

        </section>
    )
}

export default HeroSection